var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E9EFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9889 26.6241C11.8508 26.8632 11.9326 27.1691 12.1717 27.3072C12.4109 27.4453 12.7167 27.3635 12.8548 27.1244L11.9889 26.6241ZM27.147 27.1245C27.2851 27.3636 27.5909 27.4455 27.83 27.3074C28.0692 27.1692 28.151 26.8634 28.0129 26.6243L27.147 27.1245ZM12.8548 27.1244C13.5793 25.8703 14.6211 24.829 15.8755 24.1051L15.3756 23.239C13.9692 24.0506 12.8012 25.2181 11.9889 26.6241L12.8548 27.1244ZM15.8755 24.1051C17.1298 23.3811 18.5526 23 20.0009 23L20.001 22C18.3772 22 16.782 22.4273 15.3756 23.239L15.8755 24.1051ZM20.0009 23C21.4492 23 22.872 23.3812 24.1264 24.1051L24.6263 23.2391C23.2199 22.4273 21.6247 22 20.001 22L20.0009 23ZM24.1264 24.1051C25.3808 24.8291 26.4225 25.8705 27.147 27.1245L28.0129 26.6243C27.2006 25.2183 26.0326 24.0508 24.6263 23.2391L24.1264 24.1051ZM24.5009 17.5C24.5009 19.9853 22.4862 22 20.0009 22V23C23.0385 23 25.5009 20.5376 25.5009 17.5H24.5009ZM20.0009 22C17.5157 22 15.5009 19.9853 15.5009 17.5H14.5009C14.5009 20.5376 16.9634 23 20.0009 23V22ZM15.5009 17.5C15.5009 15.0147 17.5156 13 20.0009 13V12C16.9633 12 14.5009 14.4624 14.5009 17.5H15.5009ZM20.0009 13C22.4861 13 24.5009 15.0147 24.5009 17.5H25.5009C25.5009 14.4624 23.0384 12 20.0009 12V13Z",
    fill: "#5E718D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7961ae728ff4452797ab4d7f897f7a9b.svg";
export { ForwardRef as ReactComponent };